module.exports = __webpack_public_path__ + "img/retaining-wall-0.e756804e.jpeg";